import { CSSProperties } from 'react';
import { isEmpty, isNil, is } from 'ramda';

export type PixelType =
  | `${number}px`
  | CSSProperties['width']
  | CSSProperties['height']
  | CSSProperties['fontSize']
  | undefined;

export const convertPxToNumber = (pixels: PixelType): number => {
  if (!pixels) {
    return 0;
  }

  return Number(pixels.toString().replace(/px$/, ''));
};

export const formatToAmount = (number: number | undefined | null, format: string[] = ['en-NG', 'NGN']): string => {
  if (number === undefined || number === null) {
    return '-';
  }

  return number.toLocaleString(format[0], {
    style: 'currency',
    currency: format[1]
  });
};

declare type NonNull = string | number | boolean | Date | object;

export const withNullFallback = (value: NonNull | null | undefined): NonNull => {
  if (value === null || value === undefined) {
    return '-';
  }
  return value;
};

export const capitalize = (text: string | undefined) => {
  if (!text) return '';

  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const isJsonResponse = (response: Response): boolean => {
  const contentType = response.headers.get('content-type');

  return Boolean(contentType && contentType.indexOf('application/json') !== -1);
};

export const isEmptyOrNil = (data: any) => isEmpty(data) || isNil(data);

export const isBoolean = (data: unknown): boolean => is(Boolean, data);

export const getValueFromObject = (path: string[], data: any, index = 0): any => {
  if (isEmptyOrNil(data)) return data;

  const nestedObjectProp = data[path[index]];

  if (path.length !== index + 1) {
    return getValueFromObject(path, nestedObjectProp, index + 1);
  }

  return nestedObjectProp;
};

export const useWindowSizes = () => ({
  width: window.innerWidth,
  height: window.innerHeight
});

export const removeNotValidCharsFromString = (value: string, validation: (validatedValue: string) => boolean): string =>
  value
    .split('')
    .reduce((acc: string[], curr: string) => {
      acc.push(validation(curr) ? curr : '');

      return acc;
    }, [])
    .join('');
